import axios, { type AxiosError } from 'axios';
import store from 'src/store';
import { addError } from 'src/store/errorBoundarySlice';

export const handleAxiosError = (error: unknown) => {
  if (axios.isAxiosError(error) && error.response?.data?.message) {
    const data = error.response.data;
    // give a more descriptive and less confusing toast than "No message available" on 404s
    if (data.message === 'No message available' && data.error && data.path) {
      store.dispatch(addError(`${data.error} ${data.path}`));
    } else {
      store.dispatch(addError(data.message));
    }
  } else if (error instanceof Error) {
    store.dispatch(addError(error?.message));
  }
};

export const isUnauthorizedError = (error: AxiosError) => {
  const status = error.response?.status;
  if (!status || status != 401) {
    return false;
  }
  return true;
};

export const isErrorFromGetAccommodationIdByCaseIdAndLoginApi = (error: AxiosError) => {
  return error.response?.status === 400 && error.response?.data?.path?.startsWith('/accommodation/type');
};

export const isErrorFromIncidentAPI = (error: AxiosError) => {
  const { data, status } = error.request ?? {};
  const path = data?.path ?? '';
  return status === 500 && (path.startsWith('/incident/associate/') || path.startsWith('/incident/accommodation/'));
};

// export const ignoreCancelError = (onError: (error: unknown) => void) => (error: unknown) => {
//   if (!axios.isCancel(error)) onError(error);
// };

export const ignoreCancelError = <T>(requestPromise: Promise<T>, signal: AbortSignal): Promise<T> =>
  requestPromise.catch((error) => {
    // axios.isCancel would also catch cancellations not triggered by our AbortController
    // (e.g. network issues, timeouts), so we check signal.aborted to only ignore
    // cancellations we explicitly triggered
    if (!signal.aborted) throw error;
    return new Promise<T>(() => {});
  });
